// extracted by mini-css-extract-plugin
export default {"brand_categories_item":"style_brand_categories_item__kLW+8","brands_simple":"style_brands_simple__i7NmM"};